// Generated by ReScript, PLEASE EDIT WITH CARE


function getVM(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Documents"
            },
            accessor: (function ($$document) {
                return {
                        TAG: /* Text */0,
                        _0: $$document.name
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Status"
              },
              accessor: (function ($$document) {
                  return {
                          TAG: /* Text */0,
                          _0: $$document.status
                        };
                })
            },
            tl: /* [] */0
          }
        };
}

export {
  getVM ,
  
}
/* No side effect */
